import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const firebaseApp = initializeApp(firebaseConfig);

const messaging = getMessaging(firebaseApp);

export const getNotificationToken = async () => {
  const permission = await Notification.requestPermission();

  if (permission === 'granted') {
    return await getToken(messaging, {
      vapidKey: process.env.REACT_APP_VAPID_KEY,
    });
  } else if (permission === 'denied') {
    return null;
  }
};
